import Settings from '../pages/campaigns/settings/page'
import CreateCampaign from '../pages/campaigns/new/CreateCampaign'
import EditAdCampaign from '../pages/campaigns/edit/EditAdCampaign'
import DuplicateAdCampaign from '../pages/campaigns/edit/DuplicateAdCampaign'
import EditAdSet from '../pages/campaigns/edit/EditAdSet'
import Automation from '../pages/campaigns/new/Automation'
import AdsManager from '../pages/campaigns/new/adsManager'
import AddAudience from '../pages/campaigns/new/AddAudience'
import AdsetStoryline from '../pages/campaigns/new/AdsetStoryline'
import SubscriptionGate from '../components/common/SubscriptionGate'
import { Navigate } from 'react-router-dom'

const gated = (node) => <SubscriptionGate>{node}</SubscriptionGate>

export const CampaignRoutes = [
    {
        path: '',
        element: <Navigate to="/campaigns" replace />,
    },
    {
        path: ':id/settings/ad-account',
        element: gated(<Settings />),
    },
    {
        path: ':id/settings/payments',
        element: gated(<Settings />),
    },
    {
        path: ':id/create-new',
        element: gated(<CreateCampaign />),
    },
    {
        path: ':id/automation',
        element: gated(<Automation />),
    },
    {
        path: ':id/ads-manager',
        element: gated(<AdsManager />),
    },
    {
        path: ':id/ads-manager/:adCampaignId/ad-sets/:adSetId/edit',
        element: gated(<EditAdSet />),
    },
    {
        path: ':id/ads-manager/:adCampaignId/duplicate',
        element: gated(<DuplicateAdCampaign />),
    },
    {
        path: ':id/ads-manager/:adCampaignId/edit',
        element: gated(<EditAdCampaign />),
    },
    {
        path: ':id/ad_campaigns/:ad_campaign_id/add-audience',
        element: gated(<AddAudience />),
    },
    {
        path: ':id/adset-storyline/:adSetId',
        element: gated(<AdsetStoryline />),
    },
]

export default CampaignRoutes
